import { IPageData, IPageParams } from "../types";


/**
 * $t('enum.E_LaunchState.Launched')
 * $t('enum.E_LaunchState.NotLaunched')
 */
export enum E_LaunchState {
    /**
     * 启动
     */
    Launched = 0,
    /**
     * 不启动
     */
    NotLaunched = 1,
}

/**
 * 模型部件(对应后端code)
 * $t('enum.E_ModelPartial._All')
 * $t('enum.E_ModelPartial.Motor')
 * $t('enum.E_ModelPartial.Fans')
 * $t('enum.E_ModelPartial.WaterPump')
 * $t('enum.E_ModelPartial.Belt')
 * $t('enum.E_ModelPartial.AirPressure')
 * $t('enum.E_ModelPartial.Centrifugal')
 * $t('enum.E_ModelPartial.Cogs')
 * $t('enum.E_ModelPartial.Roller')
 * $t('enum.E_ModelPartial.PickupPump')
 * $t('enum.E_ModelPartial.ConveyerMachine') 
 * $t('enum.E_ModelPartial.CrushingMachine') 
 * $t('enum.E_ModelPartial.Reactor') 
 * $t('enum.E_ModelPartial.BallMill') 
 * $t('enum.E_ModelPartial.Transformer') 
 * $t('enum.E_ModelPartial.VibratingScreen') 
 * $t('enum.E_ModelPartial.SteamTurbine') 
 * $t('enum.E_ModelPartial.MachineTool') 
 * $t('enum.E_ModelPartial.WaterTurbine') 
 * $t('enum.E_ModelPartial.Generator')  
 * $t('enum.E_ModelPartial.NoCogs')  
 * $t('enum.E_ModelPartial.Other')
 */
export enum E_ModelPartial {
    /**
     * 全部
     */
    _All = -1,

    /**电机 */
    Motor = 1,
    /**风机 */
    Fans = 2,
    /**泵 */
    WaterPump = 3,
    /**皮带 */
    Belt = 4,
    /**压缩机 */
    AirPressure = 5,
    /**离心机 */
    Centrifugal = 6,
    /**齿轮箱 */
    Cogs = 7,
    /**辊子 */
    Roller = 8,
    /**
     * 真空泵
     */
    PickupPump = 10,
    /**
     * 输送机
     */
    ConveyerMachine = 11,
    /**
     * 破碎机
     */
    CrushingMachine = 12,
    /**
     * 反应釜
     */
    Reactor = 13,
    /**
     * 球磨机
     */
    BallMill = 14,
    /**
     * 变压器
     */
    Transformer = 15,

    /**
     * 振动筛
     */
    VibratingScreen = 16,
    /**
     * 汽轮机
     */
    SteamTurbine = 17,
    /**
     * 机床
     */
    MachineTool = 18,
    /**
     * 水轮机
     */
    WaterTurbine = 19,
    /**
    * 发电机
    */
    Generator = 20,
    /**
    * 非齿轮箱
    */
    NoCogs = 21,

    /**其它 */
    Other = 99,    
}

export interface IModelPageListParams extends IPageParams {
    companyId?: number
    name?: string
}

export interface IModelDiagnosisConfigResItem {
    diagnosisModelCode: string
    modelConfigId: number
    modelId: number
}

export interface IModelPageItem {
    id: number
    createTime: string
    createBy: string
    updateTime: string
    updateBy: string
    delFlag: number
    /**
     * 故障诊断
     */
    need: E_LaunchState
    /**
     * 模型名称
     */
    name: string

    path: string
    /**
     * 设备类型ID
     */
    equipmentType: number
    /**
     * 模型类型名称
     */
    equipmentTypeName: string
    /**
     * 模型图片
     */
    basekey: number

    /**
     * 如果被设备使用了，模型有的地方不能修改删除
     */
    isUsed: boolean

    modelDiagnosisConfigResVOList: IModelDiagnosisConfigResItem[]
}

export type IModelPageListData = IPageData<IModelPageItem>

/**
 * 算法模型配置
 */
export interface IModelDiagnosisConfigVO {
    /**
     * 逗号分割故障代码
     */
    diagnosisModelCode: string
    /**
     * 部件id
     */
    modelConfigId: number
}

export interface IModelCreateEditParams {
    id?: number
    companyId: number
    /**
     * 故障诊断
     */
    need: E_LaunchState
    /**
     * 模型名称
     */
    name: string
    /**
     * 
     */
    path?: string
    /**
     * 设备类型ID
     */
    equipmentTypeId: number
    /**
     * 模型图片Id
     */
    basekey?: number
    /**
     * 模型配置ID逗号隔开
     */
    modelConfig

    /**
     * 算法模型配置
     */
    modelDiagnosisConfigVOList: IModelDiagnosisConfigVO[]
}

export interface IModelConfigItem {
    code: E_ModelPartial
    id: number
    name: string
    base64: string
}

export type IModelConfigListData = IModelConfigItem[]


export interface EquipmentType {
    companyId: number;
    createBy: null;
    createTime: null;
    delFlag: number;
    id: number;
    /**
     * 模型配置逗号隔开，1电机2齿轮箱3水泵4风机5皮带6辊子7离心机8空压机9其他
     */
    modelConfig: null;
    /**
     * 模型类型
     */
    name: string;
    updateBy: null;
    updateTime: null;
}

export interface IModelGetData {
    companyId: number
    basekey: number;
    createBy: null;
    createTime: null;
    delFlag: number;
    equipmentType: EquipmentType;
    equipmentTypeId: number;
    id: number;
    /**
     * 模型名称
     */
    name: string;
    modelConfig: string
    /**
     * 故障诊断0否1是
     */
    need: E_LaunchState;
    path: string;
    updateBy: null;
    updateTime: null;
    fileUrl: string
    isUsed: boolean
    modelConfigList: IModelConfigItem[]
    /**
     * 算法模型配置
     */
    modelDiagnosisConfigResVOList: IModelDiagnosisConfigVO[]
}


export type IModelTypeGetByEquipmentTypeIdData = IModelConfigItem[]
